export default {
  SET_FAQS(state, payload) {
    state.faqs = payload;
  },
  SET_ANSWERS(state, payload) {
    state.answers = payload;
  },
  SET_ALERTS(state, payload) {
    state.alerts = payload;
  },
};
